import { leadFormApi } from "@/core/data/api";

export default async (id) => {
  return await leadFormApi.removeLeadForm(id);
};
